/**
 * PostHog analytics — loaded only after cookie consent (analytics category).
 * Removes blocking third-party script from initial page load.
 */

const POSTHOG_KEY = "phc_yJW1VjHGGwmCbbrtczfqqNxgBDbhlhOWcdzcIJEOTFE";
const POSTHOG_HOST = "https://us.i.posthog.com";

let isLoading = false;
let isLoaded = false;

export function hasAnalyticsConsent() {
  try {
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) return false;
    const prefs = JSON.parse(consent);
    return prefs.analytics === true;
  } catch {
    return false;
  }
}

export function initAnalyticsIfConsented() {
  if (isLoaded || isLoading || !hasAnalyticsConsent()) return;
  if (typeof window === "undefined") return;

  isLoading = true;

  !(function (t, e) {
    var o, n, p, r;
    e.__SV ||
      ((window.posthog = e),
      (e._i = []),
      (e.init = function (i, s, a) {
        function g(t, e) {
          var o = e.split(".");
          2 == o.length && ((t = t[o[0]]), (e = o[1])),
            (t[e] = function () {
              t.push(
                [e].concat(Array.prototype.slice.call(arguments, 0))
              );
            });
        }
        ((p = t.createElement("script")).type = "text/javascript"),
          (p.crossOrigin = "anonymous"),
          (p.async = !0),
          (p.src =
            s.api_host.replace(".i.posthog.com", "-assets.i.posthog.com") +
            "/static/array.js"),
          (r = t.getElementsByTagName("script")[0]).parentNode.insertBefore(
            p,
            r
          );
        var u = e;
        for (
          void 0 !== a ? (u = e[a] = []) : (a = "posthog"),
            u.people = u.people || [],
            u.toString = function (t) {
              var e = "posthog";
              return (
                "posthog" !== a && (e += "." + a),
                t || (e += " (stub)"),
                e
              );
            },
            u.people.toString = function () {
              return u.toString(1) + ".people (stub)";
            },
            o =
              "init capture register register_once reset opt_out_capturing has_opted_out_capturing".split(
                " "
              ),
            n = 0;
          n < o.length;
          n++
        )
          g(u, o[n]);
        e._i.push([i, s, a]);
      }),
      (e.__SV = 1));
  })(document, window.posthog || []);

  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    loaded: () => {
      isLoaded = true;
      isLoading = false;
    },
  });
}
